import { Grid, Typography } from '@mui/material';
import { useMyIntl } from 'my-intl';

import { styles } from './constants';

function Camps() {
  const imgWidth = '70%';

  const { translateMessage } = useMyIntl();

  return (
    <Grid id={styles.ids.camps} padding={'4rem 0'} sx={{ backgroundColor: styles.background.color.primary }}>
      <Grid paddingBottom={'1.2rem'}>
        <Typography
          component="div"
          variant="h2"
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          padding={'0 4rem'}
          gutterBottom
        >
          {translateMessage('camps.title')}
        </Typography>
        <Typography component="div" display={'flex'} textAlign={'center'} padding={'0 4rem'} gutterBottom>
          {translateMessage('camps.text')}
        </Typography>
      </Grid>
      <Grid container>
        <Grid size={4} display={'flex'} justifyContent={'center'}>
          <img src={translateMessage('camps.skater_1')} alt={translateMessage('camps.skater_1_alt')} width={imgWidth} />
        </Grid>
        <Grid size={4} display={'flex'} justifyContent={'center'}>
          <img src={translateMessage('camps.skater_2')} alt={translateMessage('camps.skater_2_alt')} width={imgWidth} />
        </Grid>
        <Grid size={4} display={'flex'} justifyContent={'center'}>
          <img src={translateMessage('camps.skater_3')} alt={translateMessage('camps.skater_3_alt')} width={imgWidth} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Camps;
